import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { IPagedBalanceHistoryResultRequestDto, IPagedCategoryResultRequestDto } from 'src/app/models/backend';
import { IBalanceHistoryDto } from 'src/app/models/backend/balance-history';
import { PagedListingComponentBase } from 'src/app/shared/components/paged-listing-component-base';
import { BalanceHistoriesService } from './balance-histories.service';
import { Router } from '@angular/router';
import { CreateBalanceHistoryComponent } from './create-balance-history/create-balance-history.component';
import Swal from 'sweetalert2';
import { saveAs } from 'file-saver';
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import { TransactionType } from 'src/app/models/enums';
import { LoginService } from '../login/login.service';
import { RetailersService } from '../retailers/retailers.service';


@Component({
  selector: 'app-balance-histories',
  templateUrl: './balance-histories.component.html',
  styleUrls: ['./balance-histories.component.scss']
})
export class BalanceHistoriesComponent extends PagedListingComponentBase<IBalanceHistoryDto> {
  protected override delete(entity: IBalanceHistoryDto): void {
    throw new Error('Method not implemented.');
  }
  myModel: any;
  keyword: any = '';
  categorySortingTypes: any[] = [];
  selectedCategorySortingTypes: number | null = 2;
  boolCustom = false;
  request: any = {
    skipCount: 0,
    maxResultCount: 100,
    keyword: "",
    isInvoledDeletedItems: true,
    retailerId:0,
  };
  @Output("updated") updated = new EventEmitter<boolean>();
  loader = false;
  startDate: Date = new Date();
  endDate: Date = new Date();
  isTestMode = localStorage.getItem('isTestMode')
  TestMode: any
  Role: any
  balanceHistories: IBalanceHistoryDto[] = [];

  data: any
  totalItemsCount = 0

  Retailers: any
  ddlRetailer: any
  filterRetailer: any
  retailerId: any
  constructor(
    private dialog: MatDialog,
    private modalService: NgbModal,
    private service: BalanceHistoriesService,
    public router: Router,
    public loginService: LoginService,
    private retailerService: RetailersService
  ) {
    super();
    this.Role = localStorage.getItem("RoleType")
    const today = new Date().toISOString().split('T')[0]; // Get today's date
    this.startDate = new Date();
    this.startDate.setDate(this.startDate.getDate() - 1);
    this.endDate = new Date();
    this.getRetailers()
  }
  dialogConfig = new MatDialogConfig();
  openCreateModal() {
    const modalRef = this.modalService.open(CreateBalanceHistoryComponent, {
      size: 'md', windowClass: 'mymodal', backdrop: 'static'
    });
    modalRef.closed.subscribe((o: { refresh: boolean }) => o.refresh && this.isRefresh(true));
  }
  isRefresh(refresh: boolean) { if (refresh === true) this.getDataPage(1); }

  protected override async list(request: IPagedBalanceHistoryResultRequestDto, pageNumber: number) {
    this.loader = true
    // if (localStorage.getItem("TestMode") == 'true') {
    //   this.request.isTestMode = true
    // }
    // else {
    //   this.request.isTestMode = false
    // }
    // if (this.Role == 4) {
    //   this.request.isTestMode = this.TestMode
    // }
    this.loader = true
    this.request.startDae=this.startDate
    this.request.endDate=this.endDate
    console.log(this.request)
    await this.service.getBalanceHistories(this.request).subscribe((res: any) => {
      this.balanceHistories = res.items.map(item => ({
        ...item,
        transactionType: TransactionType[item.transactionType]
      }));
      this.totalItemsCount = res.totalCount
      this.showPaging(res, pageNumber)
      this.loader = false
      console.log(res)
    })
  }

  async onPageChanged(pageNumber: number) {

    this.request = {
      isInvoledDeletedItems: false,
      skipCount: (pageNumber - 1) * 100,
      maxResultCount: 100,
      keyword: "",
      // isTestMode: false,

      // startDate: this.startDate,
      // endDate: this.endDate,
    }
    await this.service.getBalanceHistories(this.request).subscribe((res: any) => {
      this.balanceHistories = res.items.map(item => ({
        ...item,
        transactionType: TransactionType[item.transactionType]
      }));
      this.totalItemsCount = res.totalCount
      this.showPaging(res, pageNumber)
      this.loader = false
      console.log(res)
    })
    this.getDataPage(pageNumber);
  }

  onChangeFilter() {
    // this.getDataPage(1);
  }

  Filter(keyword) {
    console.log(keyword)
    this.loader = true
    this.request = {
      keyword: keyword,
      isInvoledDeletedItems: false,
      skipCount: 0,
      maxResultCount: 100,
      startDate: this.startDate,
      endDate: this.endDate,
      retailerId:this.retailerId
    }
    console.log(this.request)
    this.service.getBalanceHistories(this.request).subscribe((res: any) => {
      this.balanceHistories = res.items.map(item => ({
        ...item,
        transactionType: TransactionType[item.transactionType]
      }));
      this.showPaging(res, 1)
      this.loader = false
    })
  }
  onSelectChange(selectedValue) {
    console.log(selectedValue.value)
    selectedValue = selectedValue.value
    const today = new Date();
    const dayOfWeek = today.getDay();
    const year = today.getFullYear();
    const month = today.getMonth();
    const diff = today.getDate() - dayOfWeek + (dayOfWeek === 0 ? -6 : 1);
    const mondayOfWeek = new Date(today.setDate(diff));
    this.boolCustom = false
    switch (selectedValue) {
      case '1': // Today
        this.startDate = new Date();
        this.endDate = new Date();
        break;
      case '2': // Yesterday
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        this.startDate = yesterday;
        this.endDate = yesterday;
        break;
      case '3': // This week
        this.startDate = mondayOfWeek; // Set start date to Monday
        const endOfWeek = new Date(mondayOfWeek); // Create a new Date for the end of the week
        endOfWeek.setDate(mondayOfWeek.getDate() + 6); // Set to Sunday
        this.endDate = endOfWeek; // Set end date
        console.log(this.endDate)
        break;
      case '4': // Last Week
        const lastMonday = new Date(mondayOfWeek);
        lastMonday.setDate(lastMonday.getDate() - 7);
        const lastSunday = new Date(mondayOfWeek);
        lastSunday.setDate(lastSunday.getDate() - 1);
        this.startDate = lastMonday;
        this.endDate = lastSunday;
        break;
      case '5': // This Month
        const firstDayOfMonth = new Date(year, month, 1);
        const lastDayOfMonth = new Date(year, month + 1, 0);
        this.startDate = firstDayOfMonth;
        this.endDate = lastDayOfMonth;
        break;
      case '6': // Last Month
        const firstDayOfLastMonth = new Date(year, month - 1, 1);
        const lastDayOfLastMonth = new Date(year, month, 0);
        this.startDate = firstDayOfLastMonth;
        this.endDate = lastDayOfLastMonth;
        break;
      case '7': // Custom
        this.boolCustom = true
        this.startDate = null;
        this.endDate = null;
        break;

      default:
        this.startDate = null;
        this.endDate = null;
        break;
    }
  }

  exportData() {
    this.loader = true
    this.request.maxResultCount = this.totalItemsCount
    console.log(this.request)
    this.service.getBalanceHistories(this.request).subscribe((res: any) => {
      // this.data=res.items
      this.data = res.items.map(item => ({
        ...item,
        transactionType: TransactionType[item.transactionType]
      }));
      this.exportToCSV(this.data, 'Balance History.csv');
    })
    this.loader = false
  }
  exportToCSV(data: any[], filename: string) {
    console.log(data)
    if (data.length === 0) return;

    const headers = Object.keys(data[0]);
    const csvRows = [];

    csvRows.push(headers.join(','));

    for (const row of data) {
      csvRows.push(headers.map(fieldName => JSON.stringify(row[fieldName], (key, value) => value === null ? '' : value)).join(','));
    }

    const csvBlob = new Blob([csvRows.join('\n')], { type: 'text/csv;charset=utf-8;' });
    saveAs(csvBlob, filename);
  }
  exportDataPDF() {
    this.loader = true
    this.request.maxResultCount = this.totalItemsCount
    console.log(this.request)
    this.service.getBalanceHistories(this.request).subscribe((res: any) => {
      // this.data=res.items
      this.data = res.items.map(item => ({
        ...item,
        transactionType: TransactionType[item.transactionType]
      }));
      this.exportToPDF(this.data, 'balanceHistories.pdf');
    })
    this.loader = false
  }
  exportToPDF(data: any[], filename: string) {
    const doc = new jsPDF();

    if (data.length === 0) {
      doc.text('No data available', 14, 16);
      doc.save(filename);
      return;
    }
    const pdfHeaders = ['Retailer', 'Date', 'Transaction Type', 'Old Balance', 'New Balance', 'Payment Applied']
    const tableData = data.map(row => [
      row.retailerName,
      row.creationTime,
      row.transactionType,
      row.oldBalance,
      row.newBalance,
      row.amount
    ]);

    doc.text('Balance History', 14, 16);

    (doc as any).autoTable({
      head: [pdfHeaders],
      body: tableData,
      startY: 22,
      styles: { fontSize: 7 },
    });

    doc.save(filename);
  }
  // logout() {
  //   this.loginService.logout();
  // }
  filterRetailers(filterValue) {
    this.loader = true
    this.Retailers = this.ddlRetailer
    console.log(filterValue.value)
    this.retailerId = filterValue.value
    this.loader = false
  }
  getRetailers() {
    var request = {
      isInvloveDeletedItems: false,
      skipCount: 0,
      maxResultCount: 100,
      Keyword: ""
    }
    this.loader = true
    this.retailerService.GetRetailers(request).subscribe((res: any) => {
      this.Retailers = res.items
      this.ddlRetailer = res.items
      this.loader = false
    })
  }
}
